// extracted by mini-css-extract-plugin
export default {"BodyContainer":"_BodyContainer--kT083","Modal":"_Modal--ATSY0","Body":"_Body--bxul8"};